import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=78ac7152&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=78ac7152&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac7152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ac7152')) {
      api.createRecord('78ac7152', component.options)
    } else {
      api.reload('78ac7152', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=78ac7152&scoped=true", function () {
      api.rerender('78ac7152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layouts/main/components/Navigation.vue"
export default component.exports